var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "none",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "currentColor",
    stroke: "none",
    d: " M 27.5 15.5 Q 27.5 10.3 23.8 6.65 20.15 3 15 3 9.8 3 6.15 6.65 2.5 10.3 2.5 15.5 2.5 20.7 6.15 24.3 9.8 28 15 28 20.15 28 23.8 24.3 27.5 20.65 27.5 15.5 M 10.25 10.8 Q 12.25 8.95 15 8.95 17.7 8.95 19.65 10.8 21.5 12.8 21.5 15.5 21.5 18.2 19.65 20.2 17.7 22.05 15 22.05 12.25 22.05 10.25 20.2 8.4 18.2 8.4 15.5 8.4 12.75 10.25 10.8 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    fill: "currentColor",
    stroke: "none",
    d: " M 15 8.95 Q 12.25 8.95 10.25 10.8 8.4 12.75 8.4 15.5 8.4 18.2 10.25 20.2 12.25 22.05 15 22.05 17.7 22.05 19.65 20.2 21.5 18.2 21.5 15.5 21.5 12.8 19.65 10.8 17.7 8.95 15 8.95 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    fill: "none",
    d: " M 15 3 Q 20.15 3 23.8 6.65 27.5 10.3 27.5 15.5 27.5 20.65 23.8 24.3 20.15 28 15 28 9.8 28 6.15 24.3 2.5 20.7 2.5 15.5 2.5 10.3 6.15 6.65 9.8 3 15 3 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon-profile.575880679b58ad9c3e6a906155f61373.svg";
export { ForwardRef as ReactComponent };